import ScholarshipsDiscountsDataStoreGraphQL from '../datasources/graphql/scholarshipsDiscounts';
import ScholarshipsDiscountsDataStoreMock from '../datasources/mock/scholarshipsDiscounts';
import { ScholarshipsDiscountsDataStore } from '../datastores/ScholarshipsDiscountsDataStore';

export class ScholarshipsDiscountsDataStoreFactory {
  static create(): ScholarshipsDiscountsDataStore {
    if (process.env.DATASOURCE_ENV === 'MOCK') {
      return new ScholarshipsDiscountsDataStoreMock();
    }
    return new ScholarshipsDiscountsDataStoreGraphQL();
  }
}
